import { z } from "zod";

import { PIN_LENGTH } from "../constants/pinLength";

export const createPinSchemaWithValidation = ({
  t,
}: {
  t: (message: string) => string;
}) =>
  z.object({
    pin: z
      .string()
      .refine(
        (value) => {
          if (value.length !== PIN_LENGTH) return true;

          const numbers = value.split("").map(Number);
          return !numbers.every((number) => number === numbers[0]);
        },
        { error: t("kids_profile_pin_error_all_same") },
      )
      .refine(
        (value) => {
          if (value.length !== PIN_LENGTH) return true;

          const numbers = value.split("").map(Number);
          for (let index = 1; index < numbers.length; index++)
            if (numbers[index] !== numbers[index - 1] + 1) return true;
          return false;
        },
        { error: t("kids_profile_pin_error_consecutive") },
      ),
  });

export const pinSchema = z.object({
  pin: z.string().max(PIN_LENGTH, { error: "" }).min(PIN_LENGTH, { error: "" }),
});

export type PinSchema = z.infer<typeof pinSchema>;
